import { ICheckoutDto, ICheckoutInstanceSettingsDto, ICheckoutSession } from "@crunchit/types";
import { defaultCheckout, defaultCheckoutInstanceSettings, defaultCheckoutSession } from "./defaults";

export const checkoutFactory = (checkout: Partial<ICheckoutDto> | null = {}): ICheckoutDto => {
  return {
    ...defaultCheckout,
    ...checkout,
  };
};

export const checkoutInstanceSettingsFactory = (checkoutInstanceSettings: Partial<ICheckoutInstanceSettingsDto> | null = {}): ICheckoutInstanceSettingsDto => {
  return {
    ...defaultCheckoutInstanceSettings,
    ...checkoutInstanceSettings,
  };
};

export const checkoutSessionFactory = (checkoutSession: Partial<ICheckoutSession> | null = {}): ICheckoutSession => {
  return {
    ...defaultCheckoutSession,
    ...checkoutSession,
  };
};
